import { useContext,useEffect } from 'react'
import Header from '../Partials/Header'
import BottomNavigationBar from '../Partials/BottomNavigationBar'
import { Container } from '@mui/material'
import { Navigate, Outlet } from 'react-router-dom'
import { post } from '../utils/axios'
import { Context } from '../context/Context'

import './AppLayout.css'

const AppLayout = () => {

  const context = useContext(Context)

  useEffect(() => {
    post('User/GetUserInfo').then(({ data }) => {
      if(data.isSuccess)
        context.setProfile(data.data)
    })
    if(localStorage.getItem('authorizedGeoLocation') == 1){
      navigator.geolocation.getCurrentPosition((position) => {
        context.setlatitude(position.coords.latitude)
        context.setLongitude(position.coords.longitude)
      })
    }
  },[])

  return (
    localStorage.getItem('token') ? <div id="app-layout">
    <Container>
      <Header firstName={context.profile.firstName} lastName={context.profile.lastName} branch={context.profile.branchTitle} />
      <Outlet />
      <BottomNavigationBar />
    </Container>
  </div> : <Navigate to="/" />
  )
}

export default AppLayout